import { render, staticRenderFns } from "./LoadingPlaceholder.vue?vue&type=template&id=14bc8bf0&scoped=true"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./LoadingPlaceholder.vue?vue&type=style&index=0&id=14bc8bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14bc8bf0",
  null
  
)

export default component.exports